<template>
  <div class="setting">
    <CDNbreadcrumbs :items="items" />
    <!--  -->
    <div class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane :label="$t('allDomain.config')" name="first">
      <childDomainConfig :domainHost="rootDomain" type="main" />
    </el-tab-pane>
    <el-tab-pane :label="$t('allDomain.redirect')" name="second">
        <domainSettingItem2 :rootDomain="rootDomain" />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.cache')" name="third">
        <CacheSetting />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.strategy')" name="four">
        <CeNueSetting />
    </el-tab-pane>
  </el-tabs>
    </div>
  </div>
</template>

<script>
import domainSettingItem1 from '@/views/domain/domainSettingItem1.vue';
import domainSettingItem2 from '@/views/domain/domainSettingItem2.vue';
import CacheSetting from '@/views/products/CacheSetting.vue';
import CeNueSetting from '@/views/products/CeNueSetting.vue';
import childDomainConfig from '@/views/dev/childDomainConfig.vue';

export default {
  components: {
    domainSettingItem1,
    domainSettingItem2,
    CacheSetting,
    CeNueSetting,
    childDomainConfig,
  },
  props: {
    rootDomain: String,
  },
  data() {
    return {
      activeName: 'first',
    };
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('allDomain.DomainNames'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('allDomain.config'),
        },
      ];
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
